import React, { useState } from 'react';
import '../style/UpcomingAuctions.css';
import { auctionsData } from '../data/auctionData';

/* --- Ikon SVG (Sama seperti sebelumnya) --- */
const IconInfo = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px', color: '#94a3b8' }}><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>);
const IconChevronDown = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#64748b' }}><polyline points="6 9 12 15 18 9"></polyline></svg>);
const IconVerified = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>);
const IconCalendarGold = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#C5A065" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>);
const IconExternalLink = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '8px' }}><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>);

const UpcomingAuctions = () => {
  const [selectedAuction, setSelectedAuction] = useState(auctionsData[0]);

  const handleSelectChange = (e) => {
    const val = e.target.value;
    if (val !== "auto") {
      setSelectedAuction(auctionsData[parseInt(val)]);
    }
  };

  const formatFullDate = (date) => {
    // Menampilkan format: Rabu, 7 Januari 2026 • 19.00 WIB
    const tanggal = date.toLocaleDateString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    const jam = date.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' });
    return `${tanggal} • ${jam}`;
  };

  return (
    <div className="ua-wrapper">
      <div className="ua-container">
        
        {/* --- BAGIAN HEADER BARU --- */}
        <div className="ua-header">
            <h1 className="ua-page-title">AUCTION SCHEDULE</h1>
            <div className="ua-divider"></div>
            <p className="ua-page-desc">
                Temukan sesi lelang numismatik terbaik. Pilih jadwal di bawah ini untuk melihat detail pelaksanaan.
            </p>
        </div>
        {/* ------------------------- */}

        {/* Bagian Pilihan Sesi */}
        <div className="ua-card selection-card">
          <div className="ua-label-header">
            <IconInfo /> <span>PILIH SESI LELANG</span>
          </div>
          <div className="ua-dropdown-wrapper">
            <select onChange={handleSelectChange} className="ua-dropdown-input">
              <option value="auto">-- Tampilkan Lelang Terdekat --</option>
              {auctionsData.map((auction, index) => (
                <option key={auction.id} value={index}>
                  {auction.title}
                </option>
              ))}
            </select>
            <span className="ua-dropdown-arrow"><IconChevronDown /></span>
          </div>
        </div>

        {/* Bagian Detail Lelang */}
        <div className="ua-card main-auction-card">
          <div className="ua-card-content">
            <div className="ua-tags-row">
              <span className="ua-tag tag-dark">{selectedAuction.status}</span>
              <span className="ua-tag tag-outline"><IconVerified /> VERIFIED SESSION</span>
            </div>

            <h1 className="ua-main-title">{selectedAuction.title}</h1>
            
            {selectedAuction.image && (
                <img src={selectedAuction.image} alt={selectedAuction.title} className="ua-auction-image" />
            )}

            <p className="ua-main-desc">{selectedAuction.description}</p>

            <div className="ua-schedule-box">
              <div className="ua-schedule-icon-box"><IconCalendarGold /></div>
              <div className="ua-schedule-text">
                <span className="ua-schedule-label">JADWAL PELAKSANAAN</span>
                <span className="ua-schedule-date">{formatFullDate(selectedAuction.date)}</span>
              </div>
            </div>

            <div className="ua-highlights-section">
              <span className="ua-hl-title">HIGHLIGHT SESI</span>
              <div className="ua-hl-pills">
                {selectedAuction.highlights.map((h, i) => (
                  <span key={i} className="ua-pill">• {h}</span>
                ))}
              </div>
            </div>

            <div className="ua-action-buttons">
              <a href={selectedAuction.catalogLink} className="ua-btn ua-btn-primary" target="_blank" rel="noreferrer">
                LIHAT KATALOG LENGKAP <IconExternalLink />
              </a>
              <a href={selectedAuction.termsLink} className="ua-btn ua-btn-secondary">
                S & K LELANG
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default UpcomingAuctions;